module.exports = __webpack_public_path__ + "img/playerrank.c20ff128.png";